export const heroData = {
  title: '好联系',
  subtitle: '让每一次联系都更有价值',
  description: '专为职场人与创业者打造的人脉管理平台，帮助您高效整理联系人、智能跟进关系、挖掘潜在商机。告别杂乱通讯录，让每段关系都产生真实价值。',
  ctaPrimary: '免费开始使用',
  ctaSecondary: '了解更多',
  ctaPrimaryHref: '/#cta',
  ctaSecondaryHref: '/#features',
};

export const statsData = [
  { value: '100,000+', label: '活跃用户', icon: 'ri-user-star-line' },
  { value: '5,000,000+', label: '管理联系人', icon: 'ri-contacts-line' },
  { value: '98%', label: '用户满意度', icon: 'ri-emotion-happy-line' },
  { value: '50+', label: '行业覆盖', icon: 'ri-building-line' },
];

export const featuresData = [
  {
    id: 'smart-org',
    icon: 'ri-folders-line',
    title: '智能分组整理',
    description: '自动识别联系人属性，智能归类分组。按行业、地域、关系亲密度等多维度整理，告别手动分类的繁琐。',
    imageSeq: 'feature-org-01',
    imageQuery: 'Clean%20modern%20contact%20management%20interface%20with%20smart%20categorization%20on%20a%20device%20screen%2C%20minimalist%20design%20with%20warm%20amber%20accents%2C%20professional%20workspace%20background%20with%20soft%20natural%20lighting%2C%20organized%20contact%20cards%20with%20category%20tags%2C%20editorial%20style%20photography',
  },
  {
    id: 'relationship-track',
    icon: 'ri-heart-pulse-line',
    title: '关系动态追踪',
    description: '记录每次互动详情，智能分析联系频率。系统会自动提醒您维护重要关系，再也不会忘记跟进。',
    imageSeq: 'feature-track-02',
    imageQuery: 'Professional%20relationship%20management%20dashboard%20showing%20interaction%20timeline%20and%20relationship%20health%20metrics%2C%20warm%20amber%20and%20teal%20color%20accents%2C%20clean%20modern%20UI%20on%20laptop%20screen%2C%20minimalist%20office%20desk%20setting%20with%20natural%20light',
  },
  {
    id: 'opportunity-mining',
    icon: 'ri-lightbulb-flash-line',
    title: '商机智能挖掘',
    description: '基于您的人脉网络，AI 智能推荐潜在合作机会。让每一段关系都可能成为下一个商业突破的起点。',
    imageSeq: 'feature-opp-03',
    imageQuery: 'Business%20opportunity%20matching%20visualization%20with%20network%20graph%20and%20opportunity%20cards%20on%20screen%2C%20warm%20amber%20and%20teal%20gradient%20accents%2C%20modern%20minimalist%20design%2C%20professional%20bright%20office%20environment%2C%20high%20detail%20editorial%20photography',
  },
  {
    id: 'sync-backup',
    icon: 'ri-cloud-line',
    title: '多端同步备份',
    description: '手机、电脑、平板全平台实时同步。所有数据加密存储，即使更换设备，人脉资产也永远安全。',
    imageSeq: 'feature-sync-04',
    imageQuery: 'Multiple%20devices%20showing%20synced%20contact%20management%20app%20with%20consistent%20interface%2C%20smartphone%20tablet%20and%20laptop%20arranged%20harmoniously%20on%20wooden%20desk%2C%20warm%20lighting%2C%20minimalist%20composition%2C%20professional%20product%20photography',
  },
  {
    id: 'reminder',
    icon: 'ri-notification-3-line',
    title: '智能提醒系统',
    description: '生日、纪念日、定期联络提醒，让您不错过任何一个重要的关系维护节点。自定义提醒频率和方式。',
    imageSeq: 'feature-remind-05',
    imageQuery: 'Smart%20reminder%20notification%20interface%20on%20smartphone%20showing%20upcoming%20contact%20follow-ups%20with%20calendar%20integration%2C%20warm%20amber%20accent%20colors%2C%20clean%20minimalist%20design%2C%20phone%20on%20wooden%20desk%20with%20coffee%2C%20soft%20morning%20light',
  },
  {
    id: 'analytics',
    icon: 'ri-bar-chart-2-line',
    title: '人脉健康报告',
    description: '可视化的关系网络分析报告，了解您的人脉结构、活跃度和质量。数据驱动的关系管理决策。',
    imageSeq: 'feature-analytics-06',
    imageQuery: 'Professional%20network%20analytics%20dashboard%20with%20charts%20and%20graphs%20showing%20relationship%20health%20metrics%20on%20large%20monitor%2C%20warm%20amber%20and%20teal%20data%20visualizations%2C%20modern%20office%20setting%2C%20clean%20minimalist%20interface%2C%20editorial%20photography',
  },
];

export const functionShowcaseData = [
  {
    id: 'func-1',
    title: '一键导入，智能去重',
    description: '支持从手机通讯录、微信、钉钉、飞书、企业微信等主流平台一键导入联系人。AI 智能识别重复联系人并自动合并，清理冗余信息，让人脉库始终保持整洁有序。',
    points: ['支持 10+ 主流平台导入', 'AI 智能去重，准确率高达 99.5%', '批量标签管理，自定义分组'],
    imageSeq: 'func-import-01',
    imageQuery: 'Contact%20import%20interface%20showing%20multiple%20platform%20connection%20options%20with%20progress%20visualization%20on%20laptop%20screen%2C%20warm%20amber%20accents%2C%20clean%20modern%20UI%2C%20professional%20desk%20environment%20with%20natural%20light',
  },
  {
    id: 'func-2',
    title: '关系图谱，一目了然',
    description: '以可视化图谱展示您的人脉网络，清晰呈现每个联系人之间的关联关系。拖拽、缩放、筛选，像使用地图一样轻松浏览您的人脉世界。',
    points: ['交互式关系图谱', '多层关系穿透查看', '按行业/地区/亲密度筛选'],
    imageSeq: 'func-graph-02',
    imageQuery: 'Interactive%20network%20graph%20visualization%20showing%20professional%20connections%20with%20nodes%20and%20links%20on%20large%20display%2C%20warm%20amber%20and%20teal%20color%20scheme%2C%20modern%20office%20environment%2C%20clean%20minimalist%20design%2C%20high%20detail%20editorial',
  },
  {
    id: 'func-3',
    title: '智能提醒，永不失联',
    description: '自定义跟进规则，系统自动提醒您该联系谁、何时联系。支持多种提醒方式——APP 推送、邮件、短信，确保重要关系不被遗忘。',
    points: ['自定义跟进频率和方式', '重要日期智能识别', '多渠道提醒全覆盖'],
    imageSeq: 'func-reminder-03',
    imageQuery: 'Smart%20reminder%20dashboard%20showing%20upcoming%20follow-ups%20with%20priority%20indicators%20on%20tablet%20screen%2C%20warm%20amber%20accent%20design%2C%20clean%20modern%20interface%2C%20coffee%20shop%20background%20with%20soft%20natural%20light',
  },
];

export const testimonialsData = [
  {
    id: 't1',
    name: '张明远',
    role: '互联网公司创始人',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20business%20portrait%20in%20modern%20office%2C%20warm%20lighting%2C%20friendly%20expression%2C%20clean%20white%20background%2C%20professional%20headshot&width=120&height=120&seq=avatar-t1&orientation=squarish',
    content: '以前总是用 Excel 管理联系人，人一多就乱。好联系帮我自动归类和去重，现在 3000 多个联系人管理得井井有条。关系追踪功能更是让我再也没漏掉过任何重要客户的跟进。',
    rating: 5,
  },
  {
    id: 't2',
    name: '李婷玉',
    role: '自由职业者 / 独立顾问',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20business%20portrait%20with%20warm%20smile%2C%20modern%20office%20background%2C%20soft%20lighting%2C%20clean%20white%20background%2C%20friendly%20professional%20headshot&width=120&height=120&seq=avatar-t2&orientation=squarish',
    content: '作为独立顾问，人脉就是我的资产。好联系的商机推荐功能帮我找到了好几个合作机会，真的很惊喜。现在每次见客户前都会先看好联系里的关系记录。',
    rating: 5,
  },
  {
    id: 't3',
    name: '王浩然',
    role: '企业销售总监',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20executive%20portrait%2C%20confident%20expression%2C%20modern%20office%20setting%2C%20warm%20tone%2C%20clean%20white%20background%2C%20professional%20headshot&width=120&height=120&seq=avatar-t3&orientation=squarish',
    content: '销售团队最怕的就是客户流失。用好好联系的关系追踪和智能提醒，我们团队的回访率提升了 40%。老板都夸我管理有方，其实是工具选得好。',
    rating: 5,
  },
  {
    id: 't4',
    name: '陈晓芳',
    role: '创业者 / 天使投资人',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20entrepreneur%20portrait%2C%20confident%20warm%20smile%2C%20modern%20bright%20office%2C%20clean%20white%20background%2C%20professional%20headshot%20photography&width=120&height=120&seq=avatar-t4&orientation=squarish',
    content: '微信好友 5000 人，但真正有价值的关系需要用心维护。好联系帮我从大量社交关系中筛选出核心人脉，让我的社交精力花在最值得的地方。',
    rating: 5,
  },
  {
    id: 't5',
    name: '刘建国',
    role: '咨询公司合伙人',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20senior%20consultant%20portrait%2C%20wise%20expression%2C%20modern%20office%20environment%2C%20warm%20lighting%2C%20clean%20white%20background%2C%20professional%20headshot&width=120&height=120&seq=avatar-t5&orientation=squarish',
    content: '做咨询十几年，积累了大量人脉但管理成本越来越高。好联系的多维度标签和智能搜索，让我 3 秒内就能找到想要的人——这就是效率的提升。',
    rating: 5,
  },
  {
    id: 't6',
    name: '赵敏仪',
    role: '市场品牌经理',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20marketing%20manager%20portrait%2C%20bright%20smile%2C%20creative%20workspace%20background%2C%20warm%20lighting%2C%20clean%20white%20background%2C%20professional%20headshot&width=120&height=120&seq=avatar-t6&orientation=squarish',
    content: '做品牌合作经常需要对接不同行业的人。好联系的关系图谱让我对整个合作网络一目了然，推荐给所有需要跨界合作的朋友。',
    rating: 4,
  },
];

export const faqData = [
  {
    question: '好联系如何保护我的联系人数据安全？',
    answer: '我们采用银行级加密技术，所有联系人数据在传输和存储过程中全程加密。数据存储在通过 ISO 27001 认证的安全服务器上，我们严格遵守数据隐私法规，绝不会将您的数据用于任何未授权的用途。',
  },
  {
    question: '支持从哪些平台导入联系人？',
    answer: '目前支持从手机通讯录、微信、企业微信、钉钉、飞书、Outlook、Gmail 通讯录等主流平台导入。我们还在持续增加更多平台的支持。导入过程一键完成，并且会自动识别和合并重复联系人。',
  },
  {
    question: '可以和团队成员共享联系人吗？',
    answer: '企业版支持团队协作功能，您可以创建共享通讯录，设置不同成员的查看和编辑权限。团队成员之间可以协同维护客户关系，避免信息孤岛。',
  },
  {
    question: '免费版有哪些功能限制？',
    answer: '免费版支持管理最多 500 个联系人，包含智能分类、基础提醒和关系记录功能。升级到专业版后解锁无限联系人、AI 商机推荐、高级分析报告等全部功能。',
  },
  {
    question: '数据可以导出吗？',
    answer: '当然可以。我们支持将联系人数据导出为 Excel、CSV 等通用格式，您可以随时将数据迁移到其他平台。我们相信数据自主权属于用户。',
  },
];

export const brandsData = [
  { name: '腾讯', logo: 'https://readdy.ai/api/search-image?query=Tencent%20corporate%20logo%20text%20only%20minimalist%20clean%20design%20on%20white%20background%2C%20simple%20corporate%20branding%20style&width=200&height=80&seq=brand-tencent&orientation=landscape' },
  { name: '阿里巴巴', logo: 'https://readdy.ai/api/search-image?query=Alibaba%20corporate%20logo%20text%20only%20minimalist%20clean%20design%20on%20white%20background%2C%20simple%20corporate%20branding%20style&width=200&height=80&seq=brand-alibaba&orientation=landscape' },
  { name: '字节跳动', logo: 'https://readdy.ai/api/search-image?query=ByteDance%20corporate%20logo%20text%20only%20minimalist%20clean%20design%20on%20white%20background%2C%20simple%20corporate%20branding%20style&width=200&height=80&seq=brand-bytedance&orientation=landscape' },
  { name: '美团', logo: 'https://readdy.ai/api/search-image?query=Meituan%20corporate%20logo%20text%20only%20minimalist%20clean%20design%20on%20white%20background%2C%20simple%20corporate%20branding%20style&width=200&height=80&seq=brand-meituan&orientation=landscape' },
  { name: '京东', logo: 'https://readdy.ai/api/search-image?query=JD%20corporate%20logo%20text%20only%20minimalist%20clean%20design%20on%20white%20background%2C%20simple%20corporate%20branding%20style&width=200&height=80&seq=brand-jd&orientation=landscape' },
  { name: '华为', logo: 'https://readdy.ai/api/search-image?query=Huawei%20corporate%20logo%20text%20only%20minimalist%20clean%20design%20on%20white%20background%2C%20simple%20corporate%20branding%20style&width=200&height=80&seq=brand-huawei&orientation=landscape' },
];

export const aboutData = {
  story: {
    title: '品牌故事',
    subtitle: '从一张 Excel 表格开始的创业梦想',
    paragraphs: [
      '2019年，创始人李明远在管理自己积累 10 年的 8000 多个商务联系人时，深刻体会到了人脉管理的痛点——Excel 表格越来越臃肿、微信好友关系难以追溯、重要联系经常被遗忘。他意识到，在这个"人脉即财富"的时代，却缺少一款真正好用的工具来帮助人们经营关系。',
      '于是，他召集了一群志同道合的伙伴，他们来自阿里巴巴、腾讯、字节跳动等一线互联网公司，共同开始了"好联系"的研发之旅。经过两年多的打磨，2021年好联系正式上线，迅速获得了职场人士和创业者的青睐。',
      '今天，好联系已服务超过 10 万用户，帮助他们管理超过 500 万条联系人信息。但我们知道，这仅仅是开始。我们的使命是——让每一次联系都更有价值。',
    ],
    imageSeq: 'about-story',
    imageQuery: 'Warm%20modern%20startup%20office%20with%20team%20collaborating%20around%20large%20screen%20displaying%20contact%20management%20interface%2C%20natural%20light%20from%20large%20windows%2C%20minimalist%20interior%20design%2C%20professional%20and%20creative%20atmosphere',
  },
  values: [
    { icon: 'ri-shield-check-line', title: '用户至上', description: '一切产品决策以用户价值为出发点' },
    { icon: 'ri-lock-line', title: '数据安全', description: '采用银行级加密，守护用户数据隐私' },
    { icon: 'ri-rocket-line', title: '持续创新', description: '保持技术领先，不断突破产品边界' },
    { icon: 'ri-hand-heart-line', title: '真诚服务', description: '7×24 小时响应，用心解决每个问题' },
  ],
  contact: {
    email: 'contact@haolianxi.com',
    phone: '400-888-9999',
    address: '北京市海淀区中关村科技园区创新大厦 18 层',
    wechat: 'haolianxi_official',
  },
};